
<div class="mx-auto">
  <div class="mx-auto" *ngIf="loadingZonas">
    <div class="d-flex justify-content-center">
      <strong>Espere un momento mientras se carga la información ... 
        <div class="spinner-border" role="status"></div>
      </strong>
    </div>
  </div>

  
  <!--<table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTriggerZona" class="table-striped table-responsive">-->
  <div *ngIf="!loadingZonas">
    <div class="row">
      <div class="col-9">
      </div>
      <div class="col-3">
        <input type="text" [ngModel]="searchT" [class]="'form-control'" placeholder="Buscar..."
          (keyup)="changeSearch($event)">
      </div>
    </div>
    <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTriggerZona" class="table table-striped table-responsive" >
      <thead>
        <tr>
          <th>Acciones</th>
          <th>Nombre Foco</th>
          <th>Categorías</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let zona of zonasMantenedor | paginate: {itemsPerPage : 10, currentPage: pageActualFoco}">
          <td class="td-centered">
            <span (click)="onCreateZona(focoModal,'Editar', zona)" [ngbTooltip]="'Editar'">
              <img [src]="'assets/icons/pencil.svg'" />
            </span>
            <span (click)="openDeleteModalZona(confirmationModal, zona.foco)" [ngbTooltip]="'Eliminar'">
              <img [src]="'assets/icons/trashcan.svg'" />
            </span>
          </td>
          <td class="td-centered">{{zona.foco.focoDescription}}</td>
          <td class="td-centered td-truncated">{{getLabelCategorias(zona.categorias)}}</td>
        </tr>
      </tbody>
    </table>
    <pagination-controls (pageChange)="pageActualFoco = $event" class="pagination"></pagination-controls>
  </div>

</div>
<ng-template #focoModal let-modal>
  <app-foco-modal [modalCategoria]="modal" [categorias]="allCategorias" [focoCategorias]="focoCategorias"
    [mode]="creationMode" [categoria]="categoriaSelected">
  </app-foco-modal>
</ng-template>
<ng-template #confirmationModal let-modal>
  <app-confirmation-modal [modal]="modal" [tittle]="confirmationModalTittle" [message]="confirmationModalMessage"
    [hasComment]="confirmationModalHasComment" [hasOptions]="confirmationModalHasOptions"
    [isCommentObligatory]="confirmationModalisCommentObligatory" [optionLabel]="confirmationModalOptionLabel"
    [options]="confirmationModalOptions" (accept)="confirmationModalAccept($event.comment, $event.option)">
  </app-confirmation-modal>
</ng-template>
